// extracted by mini-css-extract-plugin
export default {"first":"First_first__kHPfQ","quoteWrapper":"First_quoteWrapper__ylsFj","quote":"First_quote__Q63yi","quotesRight":"First_quotesRight__zOl8J","quotesLeft":"First_quotesLeft__iwYBK"};